import { render } from "./AppInput.vue?vue&type=template&id=3ae067f6"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__